import { FC } from "react";
// @ts-ignore
import { FormattedNumber } from "@umijs/max";
import classNames from "classnames";

import styles from "./index.less";

import { IPriceInformation, PricingPeriodEnum } from "../../../../types";

interface PaySelectPeriodProps {
  value?: PricingPeriodEnum;
  onChange?: (value: PricingPeriodEnum) => void;
  priceInformation?: IPriceInformation;
}

/**
 * 选择付费周期
 * @returns
 */
const PaySelectPeriod: FC<PaySelectPeriodProps> = ({
  value,
  onChange,
  priceInformation,
}) => {
  if (!priceInformation) {
    return null;
  }

  return (
    <div className={styles["select-period"]}>
      <div
        className={classNames(styles.item, {
          [styles["item-selected"]]: value === PricingPeriodEnum.MONTHLY,
        })}
        onClick={() => {
          onChange?.(PricingPeriodEnum.MONTHLY);
        }}
      >
        <div className={styles.label}>按月支付</div>
        <div className={styles.price}>
          <div className={styles.num}>
            ¥
            <FormattedNumber
              value={priceInformation.monthlyPrice}
              style="decimal"
            />
          </div>
          <div className={styles.unit}>/月</div>
        </div>
      </div>
      <div
        className={classNames(styles.item, {
          [styles["item-selected"]]: value === PricingPeriodEnum.YEARLY,
        })}
        onClick={() => {
          onChange?.(PricingPeriodEnum.YEARLY);
        }}
      >
        <div className={styles.label}>按年支付</div>
        <div className={styles.price}>
          <div className={styles.num}>
            ¥
            <FormattedNumber
              value={priceInformation.yearlyPrice}
              style="decimal"
            />
          </div>
          <div className={styles.unit}>/年</div>
        </div>
        <div className={styles["yearly-tip"]}>
          {priceInformation.yearlyPayTip}
        </div>
      </div>
    </div>
  );
};

export default PaySelectPeriod;
